import React from 'react';
import { WebsiteDesignProps } from './types';
import { Film, Eye, Mic } from 'lucide-react';
import { Button } from "@/components/ui/button";

const FilmNoir: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Shadow Creek Academy";

    return (
        <div className="bg-[#1a1a1a] text-[#e5e5e5] min-h-screen font-sans">
            {/* Film Grain */}
            <div className="fixed inset-0 pointer-events-none opacity-10" style={{backgroundImage: 'url("https://www.transparenttextures.com/patterns/stardust.png")'}}></div>
            
            {/* Spotlight */}
            <div className="fixed top-0 right-0 w-[50vw] h-[100vh] bg-gradient-to-l from-white/10 to-transparent transform skew-x-12 pointer-events-none"></div>

            <nav className="p-8 flex justify-between items-center relative z-20">
                <div className="text-2xl font-bold uppercase tracking-[0.2em] text-white">
                    {schoolName}
                </div>
                <div className="flex gap-8 text-sm uppercase tracking-widest font-bold text-gray-400">
                    <a href="#" className="hover:text-white transition-colors">Scene 1</a>
                    <a href="#" className="hover:text-white transition-colors">Scene 2</a>
                    <a href="#" className="hover:text-white transition-colors">Final Cut</a>
                </div>
            </nav>

            <main className="container mx-auto px-8 py-20 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    <div>
                         <h1 className="text-6xl md:text-8xl font-bold uppercase leading-[0.85] mb-8 text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]">
                             Framing <br/> <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-800">Reality.</span>
                         </h1>
                         <div className="w-24 h-1 bg-white mb-8 shadow-[0_0_10px_white]"></div>
                         <p className="text-xl text-gray-400 mb-12 max-w-md leading-relaxed">
                             In a world of color, we teach you to see the contrast. A cinematic approach to education.
                         </p>
                         <Button className="bg-white text-black hover:bg-gray-200 rounded-none px-10 py-6 uppercase tracking-widest font-bold shadow-[4px_4px_0_gray]">
                             Roll Camera
                         </Button>
                    </div>

                    <div className="relative">
                        <div className="border border-white p-2 shadow-[0_0_20px_rgba(255,255,255,0.1)] bg-black">
                            <img src="https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=2059&auto=format&fit=crop" className="w-full grayscale contrast-150 brightness-90" alt="Noir" />
                        </div>
                        <div className="absolute -bottom-6 -left-6 bg-black border border-white p-4 text-xs font-mono uppercase tracking-widest shadow-[0_0_15px_rgba(255,255,255,0.2)]">
                            Directory: /root/students <br/> Status: Recording
                        </div>
                    </div>
                </div>

                <div className="mt-32 border-t border-gray-800 pt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center text-gray-500">
                     <div className="group hover:text-white transition-colors cursor-pointer">
                         <Film size={32} className="mx-auto mb-4 group-hover:scale-110 transition-transform" />
                         <span className="uppercase tracking-widest text-sm font-bold">Production</span>
                     </div>
                     <div className="group hover:text-white transition-colors cursor-pointer">
                         <Eye size={32} className="mx-auto mb-4 group-hover:scale-110 transition-transform" />
                         <span className="uppercase tracking-widest text-sm font-bold">Vision</span>
                     </div>
                     <div className="group hover:text-white transition-colors cursor-pointer">
                         <Mic size={32} className="mx-auto mb-4 group-hover:scale-110 transition-transform" />
                         <span className="uppercase tracking-widest text-sm font-bold">Voice</span>
                     </div>
                </div>
            </main>
        </div>
    );
};

export default FilmNoir;
